import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import ProviderTaskList from "../../components/providerPortal/ProviderTaskList";
import { fetchProviderTasks } from "../../store/providerPortal/actions";
import * as types from "../../store/providerPortal/types";

const ProviderTaskListContainer = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { tasks } = useSelector((state) => state.providerPortal);
  const [currentFilters, setCurrentFilters] = useState({});

  useEffect(() => {
    // Get initial filters from URL
    const initialFilters = {
      status: searchParams.get("status") || null,
      date_from: searchParams.get("date_from") || null,
      date_to: searchParams.get("date_to") || null,
    };
    setCurrentFilters(initialFilters);
    loadTasks(initialFilters);
  }, []);

  const loadTasks = (filters = currentFilters) => {
    const params = {};
    if (filters.status && filters.status !== "ALL") params.status = filters.status;
    if (filters.date_from) params.date_from = filters.date_from;
    if (filters.date_to) params.date_to = filters.date_to;

    dispatch(fetchProviderTasks(params)).payload.then(
      (response) => {
        dispatch({
          type: types.FETCH_PROVIDER_TASKS_SUCCESS,
          payload: response.data,
        });
      },
      (error) => {
        dispatch({
          type: types.FETCH_PROVIDER_TASKS_FAILURE,
          payload: error.response?.data || error.message,
        });
      }
    );
  };

  const handleFilterChange = (filters) => {
    setCurrentFilters(filters);
    loadTasks(filters);
  };

  const handleRefresh = () => {
    loadTasks(currentFilters);
  };

  return (
    <ProviderTaskList
      tasks={tasks.data || []}
      loading={tasks.loading}
      error={tasks.error}
      onRefresh={handleRefresh}
      onFilterChange={handleFilterChange}
    />
  );
};

export default ProviderTaskListContainer;
